// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Role$ReactHooksTemplate = require("./role.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Loading$ReactHooksTemplate = require("../dashboard/dashboard/Loading.res.js");
var Pagination$ReactHooksTemplate = require("../common/Pagination.res.js");
var RoleCreate$ReactHooksTemplate = require("./RoleCreate.res.js");
var SearchForm$ReactHooksTemplate = require("../surveys/SearchForm.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var RoleListItem$ReactHooksTemplate = require("./RoleListItem.res.js");
var PaginationUtils$ReactHooksTemplate = require("../common/PaginationUtils.res.js");

function totalRecord(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function perPage(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

var emptyPageInfo = {
  total: "1",
  per_page: "1"
};

var searchPlaceholder = "Search Roles";

function fetchRoles(currentPage, searchKey) {
  var url = searchKey !== undefined ? "/api/v1/roles?search=" + (searchKey + ("&page=" + String(currentPage))) : "/api/v1/roles?page=" + String(currentPage);
  return Js_promise.then_((function (param) {
                var headers = param[0];
                var x = headers.get("Total");
                var total = x !== null ? (
                    x === null ? undefined : Caml_option.some(x)
                  ) : "1";
                var x$1 = headers.get("Per-Page");
                var perPage = x$1 !== null ? (
                    x$1 === null ? undefined : Caml_option.some(x$1)
                  ) : "1";
                var roles = Js_promise.then_((function (json) {
                        return Promise.resolve(Json_decode.field("roles", (function (param) {
                                          return Json_decode.list(Role$ReactHooksTemplate.decode, param);
                                        }), json));
                      }), param[1]);
                return Promise.resolve([
                            roles,
                            [
                              total,
                              perPage
                            ]
                          ]);
              }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url));
}

function reducer(state, action) {
  if (typeof state !== "object") {
    if (action.TAG === "DisplayList") {
      return {
              TAG: "FetchRolesCompleted",
              _0: action._0
            };
    } else {
      return state;
    }
  }
  if (action.TAG === "DisplayList") {
    return {
            TAG: "FetchRolesCompleted",
            _0: action._0
          };
  }
  var roleId = action._0;
  var updatedRoles = List.filter(function (role) {
          return Role$ReactHooksTemplate.id(role) !== roleId;
        })(state._0);
  return {
          TAG: "FetchRolesCompleted",
          _0: updatedRoles
        };
}

function RoleList(props) {
  var match = React.useReducer(reducer, "FetchRolesInProgress");
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var hasPermission = match$1[0];
  var match$2 = React.useState(function (param) {
        return emptyPageInfo;
      });
  var setPageInfo = match$2[1];
  var pageInfo = match$2[0];
  var match$3 = React.useState(function (param) {
        return 1;
      });
  var setCurrentPage = match$3[1];
  var currentPage = match$3[0];
  var match$4 = React.useState(function (param) {
        
      });
  var setSearchKey = match$4[1];
  var searchKey = match$4[0];
  var match$5 = React.useState(function (param) {
        return false;
      });
  var setRoleCreate = match$5[1];
  var toggleRoleCreate = function (param) {
    Curry._1(setRoleCreate, (function (prev) {
            return !prev;
          }));
  };
  var match$6 = React.useState(function (param) {
        return [
                false,
                undefined
              ];
      });
  var setRoleEdit = match$6[1];
  var roleEdit = match$6[0];
  var match$7 = React.useState(function (param) {
        
      });
  var setConfirmationAction = match$7[1];
  var confirmationAction = match$7[0];
  var match$8 = React.useState(function (param) {
        
      });
  var setRoleToDelete = match$8[1];
  var roleToDelete = match$8[0];
  var refreshRoles = function (param) {
    Js_promise.then_((function (param) {
            var paginationInfo = param[1];
            var per_page = paginationInfo[1];
            var total = paginationInfo[0];
            Curry._1(setPageInfo, (function (param) {
                    return {
                            total: total,
                            per_page: per_page
                          };
                  }));
            return Js_promise.then_((function (roles) {
                          return Promise.resolve(Curry._1(dispatch, {
                                          TAG: "DisplayList",
                                          _0: roles
                                        }));
                        }), param[0]);
          }), fetchRoles(currentPage, searchKey));
  };
  var handleSearch = function (param) {
    Curry._1(setCurrentPage, (function (param) {
            return 1;
          }));
    Js_promise.then_((function (param) {
            var paginationInfo = param[1];
            var per_page = paginationInfo[1];
            var total = paginationInfo[0];
            Curry._1(setPageInfo, (function (param) {
                    return {
                            total: total,
                            per_page: per_page
                          };
                  }));
            return Js_promise.then_((function (roles) {
                          return Promise.resolve(Curry._1(dispatch, {
                                          TAG: "DisplayList",
                                          _0: roles
                                        }));
                        }), param[0]);
          }), fetchRoles(1, searchKey));
  };
  var handlePageChange = function (pageNumber) {
    Curry._1(setCurrentPage, (function (param) {
            return pageNumber;
          }));
    Js_promise.then_((function (param) {
            var paginationInfo = param[1];
            var per_page = paginationInfo[1];
            var total = paginationInfo[0];
            Curry._1(setPageInfo, (function (param) {
                    return {
                            total: total,
                            per_page: per_page
                          };
                  }));
            return Js_promise.then_((function (roles) {
                          return Promise.resolve(Curry._1(dispatch, {
                                          TAG: "DisplayList",
                                          _0: roles
                                        }));
                        }), param[0]);
          }), fetchRoles(pageNumber, searchKey));
  };
  var totalCount = Caml_format.int_of_string(pageInfo.total);
  var perPageCount = Caml_format.int_of_string(pageInfo.per_page);
  var totalPagesCount = PaginationUtils$ReactHooksTemplate.totalPages(totalCount, perPageCount);
  React.useEffect((function (param) {
          Js_promise.then_((function (param) {
                  var paginationInfo = param[1];
                  var per_page = paginationInfo[1];
                  var total = paginationInfo[0];
                  Curry._1(setPageInfo, (function (param) {
                          return {
                                  total: total,
                                  per_page: per_page
                                };
                        }));
                  Curry._1(setCurrentPage, (function (param) {
                          return 1;
                        }));
                  Curry._1(setSearchKey, (function (param) {
                          
                        }));
                  return Js_promise.then_((function (roles) {
                                return Promise.resolve(Curry._1(dispatch, {
                                                TAG: "DisplayList",
                                                _0: roles
                                              }));
                              }), param[0]);
                }), fetchRoles(1, undefined));
        }), []);
  var toggleRoleEdit = function (role) {
    Curry._1(setRoleEdit, (function (prev) {
            if (prev[0]) {
              return [
                      false,
                      undefined
                    ];
            } else {
              return [
                      true,
                      Caml_option.some(role)
                    ];
            }
          }));
  };
  var deleteRole = function (role) {
    var roleId = Role$ReactHooksTemplate.id(role);
    return Http$ReactHooksTemplate.fetchPostJSON("/api/v1/roles/" + String(roleId) + "/delete", {});
  };
  var handleDelete = function (role) {
    Js_promise.then_((function (response) {
            var roleId = Role$ReactHooksTemplate.id(role);
            var status = Json_decode.field("status", (function (param) {
                    return Json_decode.withDefault("error", Json_decode.string, param);
                  }), response);
            if (status === "success") {
              Curry._1(dispatch, {
                    TAG: "DeleteRole",
                    _0: roleId
                  });
            }
            return Promise.resolve();
          }), deleteRole(role));
  };
  if (typeof state !== "object") {
    if (Curry._1(hasPermission, "ShowRole")) {
      return JsxRuntime.jsx("p", {
                  children: "Fetching roles..."
                });
    } else {
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                        img: Caml_option.some(Image$ReactHooksTemplate.unAuthorized),
                        text: "401: Unauthorized!!",
                        loading: false
                      }),
                  className: "h-screen w-full animated fadeIn"
                });
    }
  }
  var tmp;
  if (roleEdit[0]) {
    var editRole = roleEdit[1];
    if (editRole !== undefined) {
      var editRole$1 = Caml_option.valFromOption(editRole);
      tmp = JsxRuntime.jsx("div", {
            children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: "Edit Admin Role"
                                }),
                            JsxRuntime.jsx("img", {
                                  className: "h-14-px float-right cursor-pointer",
                                  src: Image$ReactHooksTemplate.closeIcon,
                                  onClick: (function (param) {
                                      toggleRoleEdit(editRole$1);
                                    })
                                })
                          ],
                          className: "p-8 text-lg font-bold flex justify-between"
                        }),
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(RoleCreate$ReactHooksTemplate.make, {
                                role: Caml_option.some(editRole$1),
                                toggleRoleCreate: (function (param) {
                                    toggleRoleEdit(editRole$1);
                                  }),
                                refreshRoles: refreshRoles
                              }),
                          className: "flex flex-col justify-between h-full"
                        })
                  ],
                  className: "bg-white modal-survey z-10 shadow relative border border-gray-300 pointer-events-auto overflow-hidden flex flex-col"
                }),
            className: "w-screen z-10 disabled-wrapper fixed inset-0 flex justify-center items-center",
            style: {
              height: "calc(100vh + 5rem)"
            }
          });
    } else {
      tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
    }
  } else {
    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  var tmp$1;
  tmp$1 = confirmationAction === "DeleteConfirmation" ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("div", {
                              children: "Are you sure you want to delete this role?"
                            }),
                        className: "p-8 text-lg font-bold flex justify-center items-center"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("p", {
                                            children: "Cancel"
                                          }),
                                      className: "text-darkcharcoal hover:text-pigmentblue"
                                    }),
                                className: "bg-ghostwhite border border-gray-400 cursor-pointer\n                    flex justify-center items-center rounded p-2 text-sm hover:border-pigmentblue w-3/12",
                                onClick: (function (param) {
                                    Curry._1(setConfirmationAction, (function (param) {
                                            
                                          }));
                                  })
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("p", {
                                            children: "Delete"
                                          }),
                                      className: "text-white"
                                    }),
                                className: "bg-pigmentblue border border-gray-400 cursor-pointer flex justify-center items-center rounded p-2 text-sm hover:bg-cetaceanblue w-3/12",
                                onClick: (function (param) {
                                    if (roleToDelete !== undefined) {
                                      handleDelete(Caml_option.valFromOption(roleToDelete));
                                      Curry._1(setConfirmationAction, (function (param) {
                                              
                                            }));
                                      return Curry._1(setRoleToDelete, (function (param) {
                                                    
                                                  }));
                                    }
                                    
                                  })
                              })
                        ],
                        className: "p-5 flex gap-3 absolute bottom-0 w-full justify-end"
                      })
                ],
                className: "bg-white z-10 shadow relative border border-gray-300 rounded-lg h-200-px w-5/12"
              }),
          className: "z-10 disabled-wrapper absolute inset-0 flex justify-center items-center",
          style: {
            height: "calc(100vh + 5rem)"
          }
        }) : JsxRuntime.jsx(JsxRuntime.Fragment, {});
  return JsxRuntime.jsxs("div", {
              children: [
                Curry._1(hasPermission, "ShowRole") ? JsxRuntime.jsxs("div", {
                        children: [
                          Curry._1(hasPermission, "AddRole") ? JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("h2", {
                                          children: "Roles",
                                          className: "text-2xl"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(SearchForm$ReactHooksTemplate.make, {
                                                  searchKey: searchKey,
                                                  setSearchKey: setSearchKey,
                                                  handleSearch: handleSearch,
                                                  searchPlaceholder: searchPlaceholder
                                                }),
                                            JsxRuntime.jsxs("a", {
                                                  children: [
                                                    JsxRuntime.jsx("img", {
                                                          className: "h-14-px mr-1",
                                                          src: Image$ReactHooksTemplate.plusCircle
                                                        }),
                                                    "Add new Role"
                                                  ],
                                                  className: "bg-ghostwhite border border-gray-400 shadow-inner flex rounded py-2 px-3 text-xs cursor-pointer",
                                                  id: "add-role",
                                                  onClick: toggleRoleCreate
                                                })
                                          ],
                                          className: "flex items-center gap-4"
                                        })
                                  ],
                                  className: "flex justify-between items-center mb-4"
                                }) : JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("h2", {
                                          children: "Roles",
                                          className: "text-2xl"
                                        }),
                                    JsxRuntime.jsx(SearchForm$ReactHooksTemplate.make, {
                                          searchKey: searchKey,
                                          setSearchKey: setSearchKey,
                                          handleSearch: handleSearch,
                                          searchPlaceholder: searchPlaceholder
                                        })
                                  ],
                                  className: "flex justify-between items-center mb-4"
                                }),
                          JsxRuntime.jsx(Pagination$ReactHooksTemplate.Bar.make, {
                                currentPage: currentPage,
                                totalPages: totalPagesCount,
                                totalRecords: totalCount,
                                perPage: perPageCount,
                                handlePageChange: handlePageChange,
                                itemLabel: "roles",
                                className: "mb-4"
                              }),
                          JsxRuntime.jsxs("table", {
                                children: [
                                  JsxRuntime.jsx("thead", {
                                        children: JsxRuntime.jsxs("tr", {
                                              children: [
                                                JsxRuntime.jsx("th", {
                                                      children: JsxRuntime.jsxs("div", {
                                                            children: [
                                                              "Role Name",
                                                              JsxRuntime.jsx("img", {
                                                                    className: "ml-4-px",
                                                                    src: Image$ReactHooksTemplate.heading
                                                                  })
                                                            ],
                                                            className: "flex"
                                                          }),
                                                      className: "text-left w-1/6 font-extralight py-10-px pl-4"
                                                    }),
                                                JsxRuntime.jsx("th", {
                                                      children: "Description",
                                                      className: "text-left w-1/6 font-extralight py-10-px pl-4"
                                                    }),
                                                JsxRuntime.jsx("th", {
                                                      children: "Permissions",
                                                      className: "text-left font-extralight py-10-px pl-4"
                                                    }),
                                                JsxRuntime.jsx("th", {
                                                      children: JsxRuntime.jsxs("div", {
                                                            children: [
                                                              "Created at",
                                                              JsxRuntime.jsx("img", {
                                                                    className: "ml-4-px",
                                                                    src: Image$ReactHooksTemplate.heading
                                                                  })
                                                            ],
                                                            className: "flex"
                                                          }),
                                                      className: "text-left w-1/6 font-extralight py-10-px pl-4"
                                                    }),
                                                JsxRuntime.jsx("th", {
                                                      children: " ",
                                                      className: "text-left w-1/6 font-extralight py-10-px pl-4"
                                                    })
                                              ]
                                            }),
                                        className: "border border-gray-400 bg-ghostwhite text-aurometalsaurus rounded-t-lg"
                                      }),
                                  JsxRuntime.jsx("tbody", {
                                        children: $$Array.of_list(List.map((function (role) {
                                                    return JsxRuntime.jsx(RoleListItem$ReactHooksTemplate.make, {
                                                                role: role,
                                                                handleEdit: (function (param) {
                                                                    return toggleRoleEdit(role);
                                                                  }),
                                                                handleDelete: (function (param) {
                                                                    Curry._1(setRoleToDelete, (function (param) {
                                                                            return Caml_option.some(role);
                                                                          }));
                                                                    Curry._1(setConfirmationAction, (function (param) {
                                                                            return "DeleteConfirmation";
                                                                          }));
                                                                  })
                                                              }, String(Role$ReactHooksTemplate.id(role)));
                                                  }), state._0)),
                                        className: "border border-gray-400"
                                      })
                                ],
                                className: "w-full mt-10-px bg-white"
                              })
                        ],
                        className: "p-20-px"
                      }) : JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                              img: Caml_option.some(Image$ReactHooksTemplate.unAuthorized),
                              text: "401: Unauthorized!!",
                              loading: false
                            }),
                        className: "h-screen w-full animated fadeIn"
                      }),
                match$5[0] ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("div", {
                                              children: "Create New Role"
                                            }),
                                        JsxRuntime.jsx("img", {
                                              className: "h-14-px float-right cursor-pointer",
                                              src: Image$ReactHooksTemplate.closeIcon,
                                              onClick: toggleRoleCreate
                                            })
                                      ],
                                      className: "p-8 text-lg font-bold flex justify-between"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(RoleCreate$ReactHooksTemplate.make, {
                                            toggleRoleCreate: toggleRoleCreate,
                                            refreshRoles: refreshRoles
                                          }),
                                      className: "flex flex-col justify-between h-full"
                                    })
                              ],
                              className: "bg-white modal-survey z-10 shadow relative border border-gray-300 pointer-events-auto overflow-hidden flex flex-col"
                            }),
                        className: "w-screen z-10 disabled-wrapper fixed inset-0 flex justify-center items-center",
                        style: {
                          height: "calc(100vh + 5rem)"
                        }
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                tmp,
                tmp$1
              ]
            });
}

var make = RoleList;

exports.totalRecord = totalRecord;
exports.perPage = perPage;
exports.emptyPageInfo = emptyPageInfo;
exports.searchPlaceholder = searchPlaceholder;
exports.fetchRoles = fetchRoles;
exports.reducer = reducer;
exports.make = make;
/* react Not a pure module */
